<template>
  <div class="container-help" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.FAQ.k022') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <div class="title">{{ $t('lang.FAQ.k022') }}</div>
      <div class="head">{{ $t('lang.FAQ.k023') }}</div>

      <div v-if="packageName === 'echo'">
        <div class="tit">{{ $t('lang.FAQ.k006') }}</div>
        <div>{{ $t('lang.FAQ.k001') }}</div>
        <div class="tit">{{ $t('lang.FAQ.k007') }}</div>
        <div>{{ $t('lang.FAQ.k002') }}</div>
        <div class="tit">{{ $t('lang.FAQ.k008') }}</div>
        <div>{{ $t('lang.FAQ.k003') }}</div>
        <div class="tit">{{ $t('lang.FAQ.k009') }}</div>
        <div>{{ $t('lang.FAQ.k004') }}</div>
        <div class="tit">{{ $t('lang.FAQ.k010') }}</div>
        <div>{{ $t('lang.FAQ.k005') }}</div>
      </div>

      <div v-else-if="packageName === 'goparty'">
        <div class="tit">1.{{ $t('lang.FAQ.k024') }}</div>
        <div>{{ $t('lang.FAQ.k011') }}</div>
        <div class="tit">2.{{ $t('lang.FAQ.k027') }}</div>
        <div>{{ $t('lang.FAQ.k014') }}</div>
        <div class="tit">3.{{ $t('lang.FAQ.k031') }}</div>
        <div>{{ $t('lang.FAQ.k018') }}</div>
        <div class="tit">4.{{ $t('lang.FAQ.k032') }}</div>
        <div>{{ $t('lang.FAQ.k019') }}</div>
        <div class="tit">5.{{ $t('lang.FAQ.k033') }}</div>
        <div>{{ $t('lang.FAQ.k020') }}</div>
        <div class="tit">6.{{ $t('lang.FAQ.k034') }}</div>
        <div>{{ $t('lang.FAQ.k021') }}</div>
        <div class="tit">7.{{ $t('lang.FAQ.k025') }}</div>
        <div>{{ $t('lang.FAQ.k012') }}</div>
      </div>

      <div v-else-if="packageName === 'joychat'">
        <!-- 男 -->
        <div v-if="gender == 1">
          <div class="tit">1.{{ $t('lang.FAQ.k024') }}</div>
          <div>{{ $t('lang.FAQ.k011') }}</div>
          <div class="tit">2.{{ $t('lang.FAQ.k027') }}</div>
          <div>{{ $t('lang.FAQ.k014') }}</div>
          <div class="tit">3.{{ $t('lang.FAQ.k028') }}</div>
          <div>{{ $t('lang.FAQ.k015') }}</div>
          <div class="tit">4.{{ $t('lang.FAQ.k029') }}</div>
          <div>{{ $t('lang.FAQ.k016') }}</div>
          <div class="tit">5.{{ $t('lang.FAQ.k030') }}</div>
          <div>{{ $t('lang.FAQ.k017') }}</div>
          <div class="tit">6.{{ $t('lang.FAQ.k031') }}</div>
          <div>{{ $t('lang.FAQ.k018') }}</div>
          <div class="tit">7.{{ $t('lang.FAQ.k032') }}</div>
          <div>{{ $t('lang.FAQ.k019') }}</div>
          <div class="tit">8.{{ $t('lang.FAQ.k033') }}</div>
          <div>{{ $t('lang.FAQ.k020') }}</div>
          <div class="tit">9.{{ $t('lang.FAQ.k034') }}</div>
          <div>{{ $t('lang.FAQ.k021') }}</div>
          <div class="tit">10.{{ $t('lang.FAQ.k025') }}</div>
          <div>{{ $t('lang.FAQ.k012') }}</div>
          <div class="tit">11.{{ $t('lang.FAQ.k026') }}</div>
          <div>{{ $t('lang.FAQ.k013') }}</div>
        </div>
        <!-- 女 -->
        <div v-else>
          <div class="tit">1.{{ $t('lang.FAQ.k081') }}</div>
          <div>{{ $t('lang.FAQ.k038') }}</div>
          <div>{{ $t('lang.FAQ.k039') }}</div>
          <div>{{ $t('lang.FAQ.k040') }}</div>
          <div>{{ $t('lang.FAQ.k041') }}</div>
          <div>{{ $t('lang.FAQ.k042') }}</div>
          <div>{{ $t('lang.FAQ.k043') }}</div>
          <div class="tit">2.{{ $t('lang.FAQ.k083') }}</div>
          <div>{{ $t('lang.FAQ.k044') }}</div>
          <div>{{ $t('lang.FAQ.k045') }}</div>
          <div>{{ $t('lang.FAQ.k046') }}</div>
          <div>{{ $t('lang.FAQ.k047') }}</div>
          <div>{{ $t('lang.FAQ.k048') }}</div>
          <div>{{ $t('lang.FAQ.k049') }}</div>
          <div>{{ $t('lang.FAQ.k050') }}</div>
          <div class="tit">3.{{ $t('lang.FAQ.k084') }}</div>
          <div>{{ $t('lang.FAQ.k051') }}</div>
          <div>{{ $t('lang.FAQ.k052') }}</div>
          <div>{{ $t('lang.FAQ.k053') }}</div>
          <div>{{ $t('lang.FAQ.k054') }}</div>
          <div>{{ $t('lang.FAQ.k055') }}</div>
          <div>{{ $t('lang.FAQ.k056') }}</div>
          <div>{{ $t('lang.FAQ.k057') }}</div>
          <div class="tit">4.{{ $t('lang.FAQ.k085') }}</div>
          <div>{{ $t('lang.FAQ.k058') }}</div>
          <div>{{ $t('lang.FAQ.k059') }}</div>
          <div class="tit">5.{{ $t('lang.FAQ.k086') }}</div>
          <div>{{ $t('lang.FAQ.k060') }}</div>
          <div>{{ $t('lang.FAQ.k061') }}</div>
          <div>{{ $t('lang.FAQ.k062') }}</div>
          <div>{{ $t('lang.FAQ.k063') }}</div>
          <div>{{ $t('lang.FAQ.k064') }}</div>
          <div class="tit">6.{{ $t('lang.FAQ.k087') }}</div>
          <div>{{ $t('lang.FAQ.k065') }}</div>
          <div class="tit">7.{{ $t('lang.FAQ.k088') }}</div>
          <div>{{ $t('lang.FAQ.k066') }}</div>
          <div>{{ $t('lang.FAQ.k067') }}</div>
          <div>{{ $t('lang.FAQ.k068') }}</div>
          <div class="tit">8.{{ $t('lang.FAQ.k089') }}</div>
          <div>{{ $t('lang.FAQ.k069') }}</div>
          <div>{{ $t('lang.FAQ.k070') }}</div>
          <div>{{ $t('lang.FAQ.k071') }}</div>
          <div>{{ $t('lang.FAQ.k072') }}</div>
          <div>{{ $t('lang.FAQ.k073') }}</div>
          <div>{{ $t('lang.FAQ.k074') }}</div>
          <div>{{ $t('lang.FAQ.k075') }}</div>
          <div>{{ $t('lang.FAQ.k076') }}</div>
          <div class="tit">9.{{ $t('lang.FAQ.k090') }}</div>
          <div>{{ $t('lang.FAQ.k077') }}</div>
          <div>{{ $t('lang.FAQ.k078') }}</div>
          <div>{{ $t('lang.FAQ.k079') }}</div>
          <div>{{ $t('lang.FAQ.k080') }}</div>
          <div class="tit">10.{{ $t('lang.FAQ.k082') }}</div>
          <div>{{ $t('lang.FAQ.k035') }}</div>
          <div>{{ $t('lang.FAQ.k036') }}</div>
          <div>{{ $t('lang.FAQ.k037') }}</div>
        </div>
      </div>

      <div v-else-if="packageName === 'joylink'">
        <div class="tit">1.{{ $t('lang.FAQ.k096') }}</div>
        <div>{{ $t('lang.FAQ.k091') }}</div>
        <div class="tit">2.{{ $t('lang.FAQ.k097') }}</div>
        <div v-html="$t('lang.FAQ.k092')"></div>
        <div class="tit">3.{{ $t('lang.FAQ.k098') }}</div>
        <div>{{ $t('lang.FAQ.k093') }}</div>
        <div class="tit">4.{{ $t('lang.FAQ.k099') }}</div>
        <div v-html="$t('lang.FAQ.k094')"></div>
        <div class="tit">5.{{ $t('lang.FAQ.k100') }}</div>
        <div>{{ $t('lang.FAQ.k095') }}</div>
      </div>

      <div v-else="packageName === 'vava'">
        <!-- 男 -->
        <div v-if="gender == 1">
          <div class="tit">1.{{ $t('lang.FAQ.k024') }}</div>
          <div>{{ $t('lang.FAQ.k011') }}</div>
          <div class="tit">2.{{ $t('lang.FAQ.k027') }}</div>
          <div>{{ $t('lang.FAQ.k014') }}</div>
          <div class="tit">3.{{ $t('lang.FAQ.k028') }}</div>
          <div>{{ $t('lang.FAQ.k015') }}</div>
          <div class="tit">4.{{ $t('lang.FAQ.k029') }}</div>
          <div>{{ $t('lang.FAQ.k016') }}</div>
          <div class="tit">5.{{ $t('lang.FAQ.k030') }}</div>
          <div>{{ $t('lang.FAQ.k017') }}</div>
          <div class="tit">6.{{ $t('lang.FAQ.k031') }}</div>
          <div>{{ $t('lang.FAQ.k018') }}</div>
          <div class="tit">7.{{ $t('lang.FAQ.k032') }}</div>
          <div>{{ $t('lang.FAQ.k019') }}</div>
          <div class="tit">8.{{ $t('lang.FAQ.k033') }}</div>
          <div>{{ $t('lang.FAQ.k020') }}</div>
          <div class="tit">9.{{ $t('lang.FAQ.k034') }}</div>
          <div>{{ $t('lang.FAQ.k021') }}</div>
          <div class="tit">10.{{ $t('lang.FAQ.k025') }}</div>
          <div>{{ $t('lang.FAQ.k012') }}</div>
          <div class="tit">11.{{ $t('lang.FAQ.k026') }}</div>
          <div>{{ $t('lang.FAQ.k013') }}</div>
        </div>
        <!-- 女 -->
        <div v-else>
          <div class="tit">1.{{ $t('lang.FAQ.k081') }}</div>
          <div>{{ $t('lang.FAQ.k038') }}</div>
          <div>{{ $t('lang.FAQ.k039') }}</div>
          <div>{{ $t('lang.FAQ.k040') }}</div>
          <div>{{ $t('lang.FAQ.k041') }}</div>
          <div>{{ $t('lang.FAQ.k042') }}</div>
          <div>{{ $t('lang.FAQ.k043') }}</div>
          <div class="tit">2.{{ $t('lang.FAQ.k083') }}</div>
          <div>{{ $t('lang.FAQ.k044') }}</div>
          <div>{{ $t('lang.FAQ.k045') }}</div>
          <div>{{ $t('lang.FAQ.k046') }}</div>
          <div>{{ $t('lang.FAQ.k047') }}</div>
          <div>{{ $t('lang.FAQ.k048') }}</div>
          <div>{{ $t('lang.FAQ.k049') }}</div>
          <div>{{ $t('lang.FAQ.k050') }}</div>
          <div class="tit">3.{{ $t('lang.FAQ.k084') }}</div>
          <div>{{ $t('lang.FAQ.k051') }}</div>
          <div>{{ $t('lang.FAQ.k052') }}</div>
          <div>{{ $t('lang.FAQ.k053') }}</div>
          <div>{{ $t('lang.FAQ.k054') }}</div>
          <div>{{ $t('lang.FAQ.k055') }}</div>
          <div>{{ $t('lang.FAQ.k056') }}</div>
          <div>{{ $t('lang.FAQ.k057') }}</div>
          <div class="tit">4.{{ $t('lang.FAQ.k085') }}</div>
          <div>{{ $t('lang.FAQ.k058') }}</div>
          <div>{{ $t('lang.FAQ.k059') }}</div>
          <div class="tit">5.{{ $t('lang.FAQ.k086') }}</div>
          <div>{{ $t('lang.FAQ.k060') }}</div>
          <div>{{ $t('lang.FAQ.k061') }}</div>
          <div>{{ $t('lang.FAQ.k062') }}</div>
          <div>{{ $t('lang.FAQ.k063') }}</div>
          <div>{{ $t('lang.FAQ.k064') }}</div>
          <div class="tit">6.{{ $t('lang.FAQ.k087') }}</div>
          <div>{{ $t('lang.FAQ.k065') }}</div>
          <div class="tit">7.{{ $t('lang.FAQ.k088') }}</div>
          <div>{{ $t('lang.FAQ.k066') }}</div>
          <div>{{ $t('lang.FAQ.k067') }}</div>
          <div>{{ $t('lang.FAQ.k068') }}</div>
          <div class="tit">8.{{ $t('lang.FAQ.k089') }}</div>
          <div>{{ $t('lang.FAQ.k069') }}</div>
          <div>{{ $t('lang.FAQ.k070') }}</div>
          <div>{{ $t('lang.FAQ.k071') }}</div>
          <div>{{ $t('lang.FAQ.k072') }}</div>
          <div>{{ $t('lang.FAQ.k073') }}</div>
          <div>{{ $t('lang.FAQ.k074') }}</div>
          <div>{{ $t('lang.FAQ.k075') }}</div>
          <div>{{ $t('lang.FAQ.k076') }}</div>
          <div class="tit">9.{{ $t('lang.FAQ.k090') }}</div>
          <div>{{ $t('lang.FAQ.k077') }}</div>
          <div>{{ $t('lang.FAQ.k078') }}</div>
          <div>{{ $t('lang.FAQ.k079') }}</div>
          <div>{{ $t('lang.FAQ.k080') }}</div>
          <div class="tit">10.{{ $t('lang.FAQ.k082') }}</div>
          <div>{{ $t('lang.FAQ.k035') }}</div>
          <div>{{ $t('lang.FAQ.k036') }}</div>
          <div>{{ $t('lang.FAQ.k037') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Client from '@/assets/scripts/client'
import { getBaseFeature } from '@/assets/style/variable'

export default {
  data() {
    return {
      gender: '',
      appName: '',
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    getInfo() {
      const AppInfo = Client.getAppInfo()
      this.appName = AppInfo.appPackageName
      this.gender = AppInfo.gender || 1
    },
  },
  mounted() {
    this.getInfo()
  },
}
</script>
<style lang="scss" scoped>
.container-help {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  .custom-nav-block {
    background-color: #ffffff;
    .van-bar {
      ::v-deep .van-nav-bar__left .tit-left {
        font-family: var(--string-font);
        font-size: var(--fs-20);
        font-weight: var(--fw-900);
        line-height: var(--lh-title-24);
        color: #333333;
      }
    }
  }
  .main {
    padding: 0 16px 16px 16px;
    color: #666666;
    font-family: var(--string-font);
    font-size: var(--fs-14);
    line-height: var(--lh-body-20);
    .title {
      width: 100%;
      margin-bottom: 16px;
      text-align: center;
      color: #333;
      font-size: var(--fs-16);
      font-weight: var(--fw-700);
      line-height: var(--lh-title-24);
    }
    .tit {
      color: #333333;
      margin: 16px 0 8px 0;
      font-size: var(--fs-14);
      font-weight: var(--fw-700);
      line-height: var(--lh-body-20);
    }
  }
}
</style>
